<template>
	<div id="loginPanel">
        登录弹窗
	</div>
</template>
<script type="text/javascript">
   
	export default{
        
		data () {
			return{
                
			}
		},
        computed:{
           
        },
        created() {
            
        },
        methods:{
            
        },
        beforeDestroy(){
            
        }
	}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    
</style>